import { BaseClient } from './BaseClient'
import { getQueryUrlFromData } from '@/common/utils/transformFilters'

export class CreativesApi extends BaseClient {
  fetchIdenticalMedia = ({ creativeIdentical, ...params }) => {
    return this.createRequest({
      url: `/api/advertisements/identical/${creativeIdentical}`,
      method: 'get',
      params: {
        ...params,
      },
    })()
  }

  getCreatives = (params = {}, signal) => {
    return this.createRequest({
      url: `/api/advertisements/search`,
      method: 'get',
      params: {
        ...params,
      },
      paramsSerializer: (params) => {
        return getQueryUrlFromData(params)
      },
    })({}, signal)
  }

  getIdenticalAdvertisements = (id) => {
    return this.createRequest({
      url: `/api/advertisements/${id}/similar?limit=5`,
      method: 'get',
    })()
  }

  getCreativeDetails = async ({ id, token }) => {
    const { advertisement } = await this.createRequest({
      url: `/api/advertisements/details?adId=${id}`,
      method: 'get',
      ...(token && { token }),
    })()

    return advertisement
  }

  getFiltersConfig = (token, params = {}) => {
    return this.createRequest({
      url: '/api/advertisements/filters',
      method: 'get',
      ...(token && { token }),
      params,
    })()
  }

  getDomainsIp = (id) => {
    return this.createRequest({
      url: `/api/advertisements/domains-on-ip?adId=${id}`,
      method: 'get',
    })()
  }

  pinFilters = (id) => {
    return this.createRequest({
      url: `/api/filters/${id}/pin`,
      method: 'post',
    })()
  }

  unpinFilters = (id) => {
    return this.createRequest({
      url: `/api/filters/${id}/unpin`,
      method: 'post',
    })()
  }
}
